export class GrantAccessToOrganizationKeyRequest {
    otherId: number;
    organizationId: string;
    keyType: number;
    encryptionKey: string;
    dataKey: string;

}
